module.exports = __webpack_public_path__ + "media/main_theme.2d0d5115.wav";